import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';
import { GurdServiceService } from "src/app/Service/gurd-service.service";


declare let $: any;

@Component({

  selector: 'app-absence-students',

  templateUrl: './absence-students.component.html',

  styleUrls: ['./absence-students.component.css']

})

export class AbsenceStudentsComponent implements OnInit {

  dateFilter: FormGroup = this.FormBuilder.group({

    strDate: new FormControl(''),

  })

  list_Absence: any = [];

  list_search: any = [];

  lstPassenger: any = [];

  isLoading: boolean = false;

  bPresent: boolean = false;

  bStudentExam: boolean = false;

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private ActivatedRoute: ActivatedRoute,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.ActivatedRoute.url.subscribe((segment) => {

      if (segment[0].path == 'present-Students') this.bPresent = true;

      if (segment[0].path == 'AttendingExams') this.bStudentExam = true;

    })

  }

  goBack() {

    this.router.navigate(['/'])

  }

  async search_student() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strDate: this.dateFilter.value.strDate,

      tiType: this.bStudentExam ? 1 : 0
    }

    let url = this.bPresent ? 'PresenceAbsence_PresenceList' : 'PresenceAbsence_List';

    let res = JSON.parse((await axios.post(url, model)).data.toString());

    this.isLoading = false;

    this.list_Absence = res;

    this.list_search = res;

  }

  async sendMessage(form: NgForm) {

    if (form.value.strMessage == '') return this.Notification.showError('لطفا متن پیام را مشخص کنید');

    if (!form.value.bSendPush && !form.value.bSaveMessage) return this.Notification.showError('لطفا نحوه ارسال پیام را مشخص کنید');

    form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value['lstPassenger'] = this.lstPassenger;

    let res = JSON.parse((await axios.post(`School_Passenger_SendMessage`, form.value)).data.toString());

    if (res.iResult) {

      $('#sendMessage').modal('hide');

      return this.Notification.showSuccess('پیام با موفقیت ارسال شد');
    }

    else return this.Notification.showError(res.strError)


  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Absence = this.list_search.filter((el: any) => {

        return el.strMobile.includes(search) || el.strDate.includes(search) || el.strPassenger_FullName.includes(search) || el.strGrade.includes(search)

      })
    }

    else if (search == '') this.list_Absence = this.list_search
  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      let fileName = this.bPresent ? 'دانش آموزان حاضر' : this.bStudentExam ? 'گزارش دانش آموزان حاضر در امتحان' : 'دانش آموزان غایب'

      XLSX.writeFile(wb, `${fileName}.xlsx`);

    }, 200);

  }

  message_Modal() {

    if (this.lstPassenger.length == 0) return this.Notification.showError('لطفا دانش آموز مورد نظر خود را انتخاب کنید');

    $('#sendMessage').modal('show')

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstPassenger.push(item.iPassenger);

    else {

      this.lstPassenger.find((value: any) => {

        if (value === item.iPassenger) {

          const index = this.lstPassenger.indexOf(item.iPassenger);

          if (index !== -1) this.lstPassenger.splice(index, 1);

        }

      })
    }

  }

  isSelected(item: any): boolean {

    return this.lstPassenger.indexOf(item) !== -1;
  }

  selectAllCheckBox() {

    if (this.list_Absence.length > 0 && (this.list_Absence.length != this.lstPassenger.length)) {

      this.lstPassenger = [];

      this.list_Absence.forEach((a: any) => {

        this.lstPassenger.push(a.iPassenger);

      })

      this.Notification.showSuccess('همه دانش آموزان انتخاب شدند')

    }

    else {

      this.lstPassenger = [];

    }

  }



}
